import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import EventActions from '../../redux/component_select_event/actions'

// ui
import { Button } from 'antd'

// sub component
import HeadBar from './headbar'
import ListEvents from './list_events'
import Paginate from './paginate'

// props
// onSuccess(selectList): Khi nguoi dung lua chon
// onCancel(): khi nguoi dung khong chon
// initEvent: khoi tao select
class ComponentSelectEvent extends Component {
    componentDidMount() {
        if (Array.isArray(this.props.initEvent)) {
            this.props.updateSelectedEvent(this.props.initEvent)
            this.props.loadListEvents({})
        }
    }

    componentWillReceiveProps = nextProps => {
        if (
            Array.isArray(nextProps.initEvent) &&
            nextProps.initEvent !== this.props.initEvent
        ) {
            this.props.updateSelectedEvent(nextProps.initEvent)
            this.props.loadListEvents({})
        }
    }

    _onClickOk = () => {
        this.props.onSuccess(this.props.selectedEvent)
        this.props.updateTextSearch('')
        this.props.searchEvent()
        this.props.updateSelectedEvent([])
    }

    _onClickCancel = () => {
        this.props.onCancel()
    }

    render() {
        return (
            <div className="ComponentSelectEvent" style={{ width: '100%' }}>
                <HeadBar />
                <ListEvents />

                <div className="ButtonAction">
                    <Button
                        style={{ marginRight: 15 }}
                        type="primary"
                        onClick={this._onClickOk}
                    >
                        Chọn sự kiện
                    </Button>

                    <Button type="danger" onClick={this._onClickCancel}>
                        Huỷ
                    </Button>
                </div>

                <Paginate />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedEvent: state.component_select_event.selectedEvent,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadListEvents: params => {
            dispatch(EventActions.action.loadListEvents(params))
        },
        updateSelectedEvent: events => {
            dispatch(EventActions.action.updateSelectedEvent(events))
        },
        updateTextSearch: textSearch => {
            dispatch(EventActions.action.updateTextSearch(textSearch))
        },
        searchEvent: () => {
            dispatch(EventActions.action.searchEvent())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ComponentSelectEvent)
